import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import GlobalStyles from './styles/globalStyles';
import Notifications from './components/common/Notifications';
import { ToastProvider } from './components/common/ToastProvider';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Policies from './pages/Policies';
import Claims from './pages/Claims';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Manage from './pages/Manage';
import EmptyPage from './pages/EmptyPage';
import Login from './pages/Login';
import AgentStudio from './pages/AgentStudio';
import MissionControl from './pages/MissionControl';
import ClaimsTriage from './pages/ClaimsTriage';
import ClaimDetails from './pages/ClaimDetails';
import UnderwritingDetails from './pages/UnderwritingDetails';
import UnderwritingHub from './pages/UnderwritingHub';
import DocumentQueue from './pages/DocumentQueue';
import FraudVault from './pages/FraudVault';
import Personas from './pages/Personas';
import ModelHub from './pages/ModelHub';
import Performance from './pages/Performance';
import KnowledgeBase from './pages/KnowledgeBase';
import Workflows from './pages/Workflows';
import Observability from './pages/Observability';
import FeedbackLoops from './pages/FeedbackLoops';
import SecurityGovernance from './pages/SecurityGovernance';
import DataSources from './pages/DataSources';
import PromptLibrary from './pages/PromptLibrary';
import AgentPipelines from './pages/AgentPipelines';
import Tools from './pages/Tools';
import PipelineDesigner from './pages/PipelineDesigner';
import EntityList from './pages/Entity';
import EntityDetails from './pages/EntityDetail';
import KnowledgebaseDetails from './pages/KnowledgebaseDetail';
import KnowledgeBaseQuery from './pages/KnowledgeBaseQuery';
import ModelHubDetails from './pages/ModelHubDetails';
import Connector from './pages/Connector';
import ConnectorDetails from './pages/ConnectorDetails';
import Services from './pages/Services';
import ServicingDetails from './pages/ServicesDetails';
import EmailTask from './pages/EmailTask';

// Context
import { AuthProvider } from './context/AuthContext';
import EntityRecords from './pages/EntityList';
import DataSourceDetails from './pages/DataSourceDetails';
import PersonaDetails from './pages/PersonasDetails';
import PromptLibraryDetails from './pages/PromptLibrary-details';
import PipelineAnalytics from './pages/PipelineAnalytics';
import CompanyCreation from './pages/CompanyCreation';
import Company from './pages/Company';
import ClaimsHub from './pages/ClaimsHub';
import ClaimsHubDetails from './pages/ClaimsHubDetails';
import WorkStreamDetails from './pages/AllDetails';
import WorkStreamHub from './pages/AllListing';
import ErrorBoundary from './utils/ErrorBoundary';
import { useRefresh } from './context/RefreshContext';
import TaskList from './pages/TaskList';
import TaskDetails from './pages/TaskDetails';

function App() {
  const { refreshKey } = useRefresh();
  return (
    <AuthProvider>
        <ToastProvider>
      
        <Router>
          <GlobalStyles />
          <Notifications />
          <Routes>
            {/* Login route */}
            <Route path="/login" element={<Login />} />
            <Route path="/login/:provider" element={<Login />} />
            {/* Main application routes with layout */}
            <Route path="/" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <Navigate to="/email-task" replace />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                     <Dashboard />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Automation Workspace */}
            <Route path="/mission-control" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <MissionControl />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/email-task" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <EmailTask />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/email-task/:threadId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <EmailTask />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/claims-hub" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <ClaimsHub />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/workstream-hub/:workstreamname" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <WorkStreamHub />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />

              <Route path="/inbox" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <TaskList />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />

             <Route path="/inbox-details/:id" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <TaskDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/workstream-details/:workstreamname/:id" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <WorkStreamDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/new-business-details/:id" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <UnderwritingDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/new-business-hub" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <UnderwritingHub />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/document-queue" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary> 
                   <DocumentQueue />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/services" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Services />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/service-details/:id" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                     <ServicingDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/fraud-vault" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <FraudVault />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Agent Ecosystem */}
            <Route path="/agent-studio" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <AgentStudio />                   
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/personas" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <Personas />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/personas-details/:personaId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <PersonaDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/model-hub" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                     <ModelHub />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/model-hub-details/:modelId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                      <ModelHubDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/connector" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <Connector />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/connector-details/:connectorId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <ConnectorDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/tools" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                     <Tools />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/performance" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Performance />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pipeline-designer/:pipelineId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <PipelineDesigner />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pipeline-analytics/:pipelineId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <PipelineAnalytics />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Knowledge & Flows */}
            <Route path="/knowledge-base" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <KnowledgeBase />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/knowledge-base-details/:knowledgebaseId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <KnowledgebaseDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/knowledge-base-query/:knowledgebaseId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <KnowledgeBaseQuery />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/workflows" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Workflows />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/entity" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                  <EntityList />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/entity-details/:entityId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <EntityDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/entity-lists/:entityId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <EntityRecords />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/data-sources" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <DataSources />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/data-sources-details/:dsId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <DataSourceDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/prompt-library" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <PromptLibrary />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/prompt-details/:promptId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <PromptLibraryDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/agent-pipelines" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <AgentPipelines />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Governance */}
            <Route path="/security-governance" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <SecurityGovernance />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/observability" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Observability />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/policies" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Policies />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/feedback-loops" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                  <FeedbackLoops />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* System */}
            <Route path="/analytics" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Analytics />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                  <Settings />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/manage" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                  <Manage />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />

              <Route path="/manage/company/:id" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <CompanyCreation />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />

               <Route path="/create/company/" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <CompanyCreation />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/company" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                   <Company />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Legacy routes - can be removed if not needed */}
            <Route path="/claims" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Claims />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Default redirect to login */}
            <Route path="*" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <Navigate to="/login" replace />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
